import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "./mockData";


export const editSignupBackgroundColor = async ({
  signupID,
  color,
  colorScheme,
}) => {
  const endpoint = `/signuplist/${signupID}/backgroundcolor`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.editSignupBackgroundColor, 3000)
    : new FnrFetch3(endpoint, {
        backgroundColor: color,
        colorScheme: colorScheme,
      });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const uploadPhoto = async (formData, options) => {
  const endpoint = `/upload/photo/misc`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.uploadPhoto, 3000)
    : new FnrFetch3(endpoint, formData, options);

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: err.error ?? `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const editMediaSettings = async ({ signupID, newMediaSettings }) => {
  const endpoint = `/signuplist/${signupID}/media`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.editMediaSettings, 3000)
    : new FnrFetch3(endpoint, newMediaSettings);

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const editDescription = async ({ signupID, description }) => {
  const endpoint = `/signuplist/${signupID}/editdescription`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.editDescription, 3000)
    : new FnrFetch3(endpoint, {
        signupListID: signupID,
        description,
      });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};